import React, { ReactNode } from 'react';

import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/tailwind';

import { TAG_TEST_IDS } from '../../../constants/data-testids';

const tagVariants = cva('inline-flex items-center rounded-[5px] gap-1', {
  variants: {
    type: {
      background: '',
      outlined: 'outline',
    },
    size: {
      small: 'text-body-12-medium px-1',
      regular: 'text-body-12-medium px-2 py-[3px]',
      large: 'text-body-14-medium px-2.5 py-0.5',
      'x-large': 'text-body-14-medium px-2.5 py-1.5',
    },
    color: {
      green: 'bg-custom-green-200 !text-custom-green-800',
      beige: 'bg-custom-beige-200 !text-custom-beige-800',
      cyan: 'bg-custom-cyan-50 !text-custom-cyan-600',
      blue: 'bg-custom-blue-50 !text-custom-blue-700',
      grey: 'bg-custom-warm-grey-150 !text-custom-warm-grey-600',
      'light-blue': 'bg-custom-light-blue-50 !text-custom-light-blue-700',
      orange: 'bg-custom-orange-50 !text-custom-orange-700',
      pink: 'bg-custom-pink-50 !text-custom-pink-700',
      purple: 'bg-custom-purple-50 !text-custom-purple-700',
      red: 'bg-custom-red-100 !text-custom-red-700',
      yellow: 'bg-custom-yellow-50 !text-custom-yellow-700',
    },
  },
  defaultVariants: {
    type: 'background',
    size: 'regular',
    color: 'cyan',
  },
});

export type TagProps = VariantProps<typeof tagVariants> & {
  label: string;
  className?: string;
  labelClassName?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
};

export const Tag: React.FC<TagProps> = ({
  label,
  type,
  size,
  color,
  leftIcon,
  rightIcon,
  className,
  labelClassName,
}) => {
  return (
    <span
      data-testid={TAG_TEST_IDS.SPAN}
      className={cn(tagVariants({ type, size, color, className }))}
    >
      {leftIcon}
      <span data-testid={TAG_TEST_IDS.LABEL} className={labelClassName}>
        {label}
      </span>{' '}
      {rightIcon}
    </span>
  );
};
